import { render, staticRenderFns } from "./PopupAgreementsCookies.vue?vue&type=template&id=5668afd9&scoped=true&"
import script from "./PopupAgreementsCookies.vue?vue&type=script&lang=js&"
export * from "./PopupAgreementsCookies.vue?vue&type=script&lang=js&"
import style0 from "./PopupAgreementsCookies.vue?vue&type=style&index=0&id=5668afd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5668afd9",
  null
  
)

export default component.exports